import React from 'react';
import { parseRenderOptions } from './utils';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';
import { Tooltip } from '../Tooltip';

/******************************************************************************
 * Single Field
 ******************************************************************************/

export const PrefixTextField = props => {
  const renderOptions = parseRenderOptions(props, { isFloating: false });
  const prefix =
    typeof renderOptions.custom.prefix === 'function'
      ? renderOptions.custom.prefix(props.bindings)
      : renderOptions.custom.prefix;

  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <div
        className={classNames('input-group', renderOptions.fieldClassName, {
          'input-group-sm': renderOptions.size === 'sm',
        })}
      >
        {prefix && (
          <Tooltip content={prefix} delay={{ show: 300 }}>
            {({ ref }) => (
              <div
                className="input-group-text text-truncate max-w-50 d-block fw-normal"
                ref={ref}
              >
                {prefix}
              </div>
            )}
          </Tooltip>
        )}
        <input
          ref={props.focusRef}
          className={classNames('form-control', renderOptions.fieldClassName, {
            'form-control-sm': renderOptions.size === 'sm',
            'is-invalid': renderOptions.hasErrors,
            'has-btn': !!props.value,
            'is-empty': !props.value,
          })}
          type="text"
          id={props.id}
          name={props.name}
          value={props.value}
          onBlur={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          placeholder={renderOptions.placeholder}
          disabled={!props.enabled}
          form={props.form}
        />
      </div>
    </FieldWrapper>
  );
};
